/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * Stepper CSS
 */
export const styles = css`
	*{
		box-sizing:border-box;
	}
	:host {
		display:block;
		height:100%;
		-webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
	}
	.nile-stepper--horizontal{
		display:flex;
		align-items:center;
		padding: var( --nile-spacing-spacing-3xl, var(--ng-spacing-2xl));
	}

	.nile-stepper--vertical{
		height:100%;
		display:flex;
		flex-direction:column;
		padding: var( --nile-spacing-spacing-3xl, var(--ng-spacing-2xl));
	}
`;

export default [styles];
